import { defineAsyncComponent } from 'vue'
export default {
  "standalone-snowplow-layout": defineAsyncComponent(() => import("/codebuild/output/src3150998498/src/layouts/StandaloneSnowplowLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src3150998498/src/layouts/default.vue").then(m => m.default || m))
}